module.exports = __webpack_public_path__ + "static/bootstrap-table-highlight-9540167a78fdac80ea8610798dd58a8c.png";